import { useEffect, useRef } from 'react';

export const useCloseOnOutsideClick = (
  ref: React.RefObject<HTMLElement | null>,
  close: () => void
) => {
  const closeRef = useRef(close);
  closeRef.current = close;

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        closeRef.current();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [ref]);
};
